import React from 'react';

const Selo: React.FC<{ classe: string; titulo?: string; children: React.ReactNode }> = ({ classe, titulo, children }) => (
  <span
    title={titulo}
    className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${classe}`}
  >
    {children}
  </span>
);

export default Selo;
